<template>
  <div class="row chart findings-container">
    <div class="col-100">
      <!-- <div class="slider-divider"></div> -->

      <h3>Correlations of MS Findings<sup>1,2,</sup>*</h3>
      <h3>Advance the Slider to Explore MS Disease Progression</h3>

      <div class="chart-slider-spacer">
        <div class="scrollable" @scroll.passive="handleScroll">
          <div v-show="showFadeLeft" class="scroll-fade-left" />
          <div v-show="showFade" class="scroll-fade" />
          <FindingsChart />
          <div class="chart-slider-spacer-slider">
            <YearSlider />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YearSlider from "@/components/YearSlider.vue";
import FindingsChart from "@/components/FindingsChart.vue";

export default {
  name: "FindingsTutorial",
  components: {
    YearSlider,
    FindingsChart,
  },
  props: {},
  data() {
    return {
      showFade: true,
      showFadeLeft: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleScroll(e) {
      const el = e.srcElement;
      this.showFade = el.scrollLeft < el.scrollWidth - el.offsetWidth;
      this.showFadeLeft = el.scrollLeft > 10;
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: rem(14px);
  margin-bottom: 10px;
}

.findings-container {
  margin-top: 25px;
}

.row.chart {
  position: relative;
  z-index: 1;
  background: $grey;

  .col-100 {
    padding: rem(20px) rem(20px);
    border: none;
  }

  * {
    color: $black;
  }
}

.chart-slider-spacer {
  padding: 0 0 0 1rem;

  @include breakpoint(xs) {
    padding: 0;
    // width: 275px;
    width: calc(100vw - 90px);
    height: 370px;
    position: relative;
  }
}

.chart-slider-spacer-slider {
  padding: 0 0 0 1rem;
  @include breakpoint(xs) {
    width: 935px;
  }
}

.row.slider {
  margin: 20px 0 0;
}

.slider-divider {
  background: #c6c6c6;
  width: 99%;
  height: 1px;
  position: relative;
  margin: 10px auto;
}

.instructions-container {
  display: flex;
  align-items: center;
  border: 1px solid #707070;
  padding: 5px;
  margin-bottom: 18px;

  .instructions-icon {
    display: flex;
    align-items: center;
    margin: 0 10px 0 5px;
  }
  .instructions-txt {
    p {
      font-size: rem(12px);
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@include breakpoint(xs) {
  .scrollable {
    overflow-x: scroll;
    overflow-y: visible;
    height: 370px;
  }

  .scroll-fade {
    position: absolute;
    right: -1px;
    top: 0;
    z-index: 10;
    width: 75px;
    height: 100%;
    // box-shadow: inset -60px 0 40px -30px $white;
    pointer-events: none;
    background: linear-gradient(to left, white, rgba(250, 250, 250, 0));
  }
  .scroll-fade-left {
    position: absolute;
    left: -1px;
    top: 0;
    z-index: 15;
    width: 75px;
    height: 100%;
    // box-shadow: inset 60px 0 40px -30px $white;
    pointer-events: none;
    background: linear-gradient(to right, white, rgba(250, 250, 250, 0));
  }
}
</style>
